<template>
  <!-- Tabs Documentos en Transito -->

  <v-row v-resize="onResize" no-gutters align="start" justify="center">
    <v-col cols="12">
      <v-data-table
        :loading="peticionDocCliente ? '#002f6c' : null"
        :hide-default-header="isMobile"
        :class="{ mobile: isMobile }"
        :height="$route.name == 'AgendaVista' ? '300px' : '600px'"
        fixed-header
        dense
        id="tbl_datos"
        :headers="headersClienteTrn"
        :items="datosNew"
        :search="search"
        hide-default-footer
        disable-pagination
        single-select
        sort-by="position"
        sort-desc
        show-group-by
        group-desc
        item-key="NumeroPed"
        class="elevation-1"
        group-by="Codigo"
        :mobile-breakpoint="0"
      >
        <!-- toolbar-->
        <template v-slot:top>
          <v-toolbar flat class="d-print-none">
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              dense
              outlined
              color="primary"
              single-line
              append-icon="mdi-magnify"
              label="Buscar"
              clearable
              clear-icon="mdi-close-circle"
              hide-details
              type="text"
              background-color="#EEEEEE"
              class="shrink d-print-none"
            ></v-text-field>
          </v-toolbar>
        </template>
        <!-- group-->
        <template
          v-slot:[`group.header`]="{ items, group, headers, toggle, isOpen }"
        >
          <td :colspan="headers.length">
            <v-btn @click="toggle" x-small icon :ref="group">
              <v-icon v-if="isOpen">mdi-minus</v-icon>
              <v-icon v-else>mdi-plus</v-icon>
            </v-btn>
            <span style="color: #002f6c" class="mx-6 font-weight-bold">
              {{
                items
                  .filter((x) => x.Codigo === group)
                  .map((x) => x.NombreCli)[0]
              }}
            </span>
          </td>
        </template>
        <!-- sumary-->
        <template v-slot:[`group.summary`]="{ items, group }" v-if="!isMobile">
          <td colspan="6"></td>
          <td :class="['text-right font-weight-bold body-2']">
            <span>{{ `${simboloMoneda[tipoMoneda]} ` }}</span>
            {{
              items
                .filter((x) => x.Codigo === group)
                .map((x) => x.Monto[tipoMoneda])
                .reduce((a, b) => a + b, 0) | numeral("0,0.00")
            }}
          </td>
        </template>
        <!-- data -->
        <template v-slot:item="{ item }">
          <tr :data-category-id="item.Codigo" :data-id="item.NumeroPed">
            <td class="d-print-none">
              <linkfact
                :itemfac="true"
                :numerodoc="item.NumeroPed"
                :tipodoc="item.TipoDoc"
                :idtab="2"
                :transi="false"
              ></linkfact>
            </td>
            <td :class="['text-center']">
              {{ item.NumeroPed }}
            </td>
            <td :class="['text-center']">
              {{ item.Referencia }}
            </td>
            <td :class="['text-center']">
              {{
                item.FechaPedido
                  ? moment(item.FechaPedido).format("DD/MM/YY")
                  : ""
              }}
            </td>
            <td :class="['text-center']">
              {{ item.Transporte }}
            </td>
            <td :class="['text-center']">
              {{ item.StatusPed }}
            </td>
            <td :class="['text-right']">
              <span>{{ `${simboloMoneda[tipoMoneda]} ` }}</span>
              {{ format(item.Monto[tipoMoneda], 1) }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import linkfact from "@/components/DatosFactura.vue";
import { format } from "@/static/funciones";
export default {
  props: {
    idcliente: Number,
  },
  created() {
    this.CRL_DetalleClienteTrn();
    this.get_DetalleClienteDoc({ cliente: this.idcliente });
  },
  methods: {
    ...mapActions(["get_DetalleClienteDoc"]),
    ...mapMutations(["CRL_DetalleClienteTrn"]),
    format,
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
  },
  computed: {
    ...mapState([
      "peticionDocCliente",
      "DetalleClienteTrn",
      "simboloMoneda",
      "tipoMoneda",
    ]),
    datosNew() {
      let xdatos = [];
      if (Object.entries(this.DetalleClienteTrn).length !== 0) {
        let { wfpedido: wfpedido } = this.DetalleClienteTrn;
        if (Object.entries(wfpedido).length !== 0) {
          xdatos = wfpedido;
        }
      }
      return xdatos;
    },
  },
  components: {
    linkfact,
  },
  data() {
    return {
      isMobile: false,
      search: "",

      headersClienteTrn: [
        {
          text: "Ver",
          align: "center",
          value: "NumeroPed",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold d-print-none",
        },
        {
          text: "Pedido",
          align: "center",
          value: "NumeroPed",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Referencia",
          align: "center",
          value: "Referencia",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Fecha Pedido",
          align: "center",
          value: "FechaPedido",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Transporte",
          align: "center",
          value: "Transporte",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Estatus",
          align: "center",
          value: "StatusPed",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Monto",
          align: "right",
          value: "StatusPed",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
      ],
    };
  },
};
</script>

<style scoped>
.v-cardgrid {
  background-color: #ffffff !important;

  border: 1px solid #fe5000 !important;

  transition: opacity 0.4s ease-in-out;
  margin: 1px;
}
.tbl_datos tr:nth-child(odd) {
  background: #ffffff;

  font-size: 11px;
  padding: 1px;
}
.tbl_datos tr:nth-child(even) {
  font-size: 11px;
  background: #e0e0e0;
  padding: 1px;
}

.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;

  height: 40px;
  font-weight: bold;
}
.flex-txt {
  padding: 6px;
  width: 50%;
  height: 45px;
}
</style>
